const data = [
  {
    chapterIndex: '',
    text: '',
    items: [
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Hello<span></b>', pageNumber: 3 },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 1:<span></b> Look at me!',
        pageNumber: 5,
      },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 2:<span></b> Lucy is sad',
        pageNumber: 15,
      },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 3:<span></b> Let’s go shopping',
        pageNumber: 25,
      },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 4:<span></b> Family lunch',
        pageNumber: 35,
      },
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Unit 5:<span></b> My dream job', pageNumber: 45 },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 6:<span></b> A family trip',
        pageNumber: 55,
      },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 7:<span></b> What are you doing?',
        pageNumber: 65,
      },
      {
        chapterIndex: '',
        text: '<b><span style="color: #42abb9;">Unit 8:<span></b> Summer Camp',
        pageNumber: 75,
      },
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Christmas<span></b>', pageNumber: 85 },
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Maths Day<span></b>', pageNumber: 87 },
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Saint Patrick’s Day<span></b>', pageNumber: 89 },
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Extra reading<span></b>', pageNumber: 91 },
      { chapterIndex: '', text: '<b><span style="color: #42abb9;">Picture dictionary<span></b>', pageNumber: 92 },
    ],
  },
];
// const data2 = [
//   {
//     chapterIndex: '',
//     text: '',
//     items: [
//       { chapterIndex: '', text: '<b><span style="color: #42abb9;">Hello<span></b>', pageNumber: 2 },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 1:<span></b> Look at me!',
//         pageNumber: 4,
//       },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 2:<span></b> Lucy is sad',
//         pageNumber: 14,
//       },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 3:<span></b> Let’s go shopping',
//         pageNumber: 24,
//       },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 4:<span></b> Family lunch',
//         pageNumber: 34,
//       },
//       { chapterIndex: '', text: '<b><span style="color: #42abb9;">Unit 5:<span></b> My dream job', pageNumber: 44 },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 6:<span></b> A family trip',
//         pageNumber: 54,
//       },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 7:<span></b> What are you doing?',
//         pageNumber: 64,
//       },
//       {
//         chapterIndex: '',
//         text: '<b><span style="color: #42abb9;">Unit 8:<span></b> Summer Camp',
//         pageNumber: 74,
//       },
//       { chapterIndex: '', text: '<b><span style="color: #42abb9;">Christmas<span></b>', pageNumber: 84 },
//       { chapterIndex: '', text: '<b><span style="color: #42abb9;">Maths Day<span></b>', pageNumber: 86 },
//       { chapterIndex: '', text: '<b><span style="color: #42abb9;">Saint Patrick’s Day<span></b>', pageNumber: 88 },
//       { chapterIndex: '', text: '<b><span style="color: #42abb9;">Revision pages<span></b>', pageNumber: 90 },
//     ],
//   },
// ];

export default { 'fun-time': data };
